import { render, staticRenderFns } from "./PartnershipPane.vue?vue&type=template&id=2e635050&"
import script from "./PartnershipPane.vue?vue&type=script&lang=ts&"
export * from "./PartnershipPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports